// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-app_container__Op_BY"};